import React, { useState } from "react"
import { ArrowDownOrder } from "../../../assets/icons/ArrowDownOrder"
import styles from "./index.module.scss"
import { orderColumns } from "@tanstack/react-table"
import "./style.css"

export const Order = ({ columnIndex, activeColumnIndex, setActiveColumnIndex }) => {
  const isActive = columnIndex === activeColumnIndex

  const fnHandleChangeArrow = () => {
    setActiveColumnIndex(isActive ? null : columnIndex)
  }

  return (
    <div
      className={`${styles.containerArrow} container-arrow`}
      onClick={fnHandleChangeArrow}
    >
      <ArrowDownOrder
        width={15}
        height={20}
        className={styles.arrow}
        style={{
          transform: isActive ? "rotate(-180deg)" : "rotate(0deg)",
        }}
      />
    </div>
  )
}
